export const ASSET_IT_BASE_PATH = 'assets';
export const ASSET_IT_DEFAULT_HUB = 'it';
export const ASSET_IT_DEFAULT_MODULE = 'on-prem';
export const ASSET_IT_ON_PREM_ROUTE = `${ASSET_IT_BASE_PATH}/${ASSET_IT_DEFAULT_HUB}/${ASSET_IT_DEFAULT_MODULE}`;
export const CREATE_ASSET_PATH = 'create';
export const SIGN_IN_PATH = 'sign-in';
export const ALLOCATE_ASSET_PATH = 'api/v1/ams/organizations';
export const COMMON_END_POINT = '/api/v1/auth/';
export const ORGANIZATION_END_POINT = '/api/v1/auth/admin/organizations/';
export const GLOBAL_SEARCH_PATH = 'api/v1/search/organizations';
export const USER_VIEW_PATH = 'my';
export const MY_ASSETS_PATH = `${USER_VIEW_PATH}/assets`;
export const NEW_ORGANIZATION_PATH = '/organizations/new';
export const TRACKERS_STATUS_PATH = 'api/v1/ams/admin/trackers/organizations';
